export const Z_INDEX_MAX = 9999;
export const WHITE = '#fff';
export const BRAND_BLACK = '#202124';
export const INACTIVE_GRAY = '#dbdbdb';
export const NATIONAL_TWO_REGULAR = 'National 2 Regular';

const STYLE_SCRIPT_CONST = {
  HEADER_STYLES: 'HEADER_STYLES',
  START_ORDER_STYLES: 'START_ORDER_STYLES',
  START_ORDER_BTN_STYLES: 'START_ORDER_BTN_STYLES',
  DISPOSITION_BAR_STYLES: 'DISPOSITION_BAR_STYLES',
  FOOTER_STYLES: 'FOOTER_STYLES',
  STICKY_TOP_VALUES: 'STICKY_TOP_VALUES',
  MENU_CATEGORY_STYLES_DESKTOP: 'MENU_CATEGORY_STYLES_DESKTOP',
  MENU_CATEGORY_STYLES_MOBILE: 'MENU_CATEGORY_STYLES_MOBILE',
  CONTACT_US_CONTAINER_STYLES: 'CONTACT_US_CONTAINER_STYLES',
  FAQ_CONTAINER_STYLES: 'FAQ_CONTAINER_STYLES',
  OUR_ADS_STYLES: 'OUR_ADS_STYLES',
  PRIVACY_POLICY_STYLES: 'PRIVACY_POLICY_STYLES',
  TERMS_OS_USE_STYLES: 'TERMS_OS_USE_STYLES',
  PROTECTED_DISCLOSURE_STYLES: 'PROTECTED_DISCLOSURE_STYLES',
};

export default STYLE_SCRIPT_CONST;
